import React, { useContext } from "react";
import commonContext from "../../../context/common";

function LoanDetailsReview() {
    const { lead, utils } = useContext(commonContext);
    return (
        <>
            <h1 className="openSans-Reg text-black my-8 text-3xl md:text-3xl lg:text-3xl xl:text-4xl">
                Loan Details
            </h1>
            <div className="details-blue-wrap w-full pb-3 md:pb-5 xl:pb-5">
                <ul className="flex flex-wrap justify-between lg:flex-row">
                    <li className="mb-3 lg:mb-0 w-1/2 lg:w-3/12">
                        <p className="openSans-Reg light-gray-1 text-xs md:text-base lg:text-base xl:text-base">
                            EMI
                        </p>
                        <p className="openSans-Reg text-black text-base sm:text-xl md:text-2xl">
                            <span className="WebRupee">Rs.</span>
                            {lead.emi}
                        </p>
                    </li>
                    <li className="mb-3 lg:mb-0 w-1/2 lg:w-3/12">
                        <p className="openSans-Reg light-gray-1 text-xs md:text-base lg:text-base xl:text-base">
                            Interest Rate
                        </p>
                        <p className="openSans-Reg text-black text-base sm:text-xl md:text-2xl">
                            {lead.interestRate}%
                        </p>
                    </li>
                    <li className="mb-3 lg:mb-0 w-1/2 lg:w-3/12">
                        <p className="openSans-Reg light-gray-1 text-xs md:text-base lg:text-base xl:text-base">
                            Tenure
                        </p>
                        <p className="openSans-Reg text-black text-base sm:text-xl md:text-2xl">
                            {lead.liTenure} months
                        </p>
                    </li>
                    <li className="mb-3 lg:mb-0 w-1/2 lg:w-3/12">
                        <p className="openSans-Reg light-gray-1 text-xs md:text-base lg:text-base xl:text-base">
                            First EMI Due Date
                        </p>
                        <p className="openSans-Reg text-black text-base sm:text-xl md:text-2xl">
                            {utils.getDateInFormat(lead.emiStartDate)}
                        </p>
                    </li>
                </ul>
            </div>
        </>
    );
}

export default LoanDetailsReview;
